"use client";

import React from "react";
import { ArrowRight, BookOpen } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WorkWithUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="239691" id="work-with-us" className="bg-background py-16 md:py-24 px-4 sm:px-6 lg:px-8 overflow-hidden border-t-2 border-b-2 border-foreground">
      <div className="max-w-4xl mx-auto" ref={ref}>
        <Card className={`relative overflow-hidden border-border bg-card shadow-2xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-foreground to-transparent opacity-20" />
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-foreground/5 rounded-lg blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-foreground/5 rounded-lg blur-3xl pointer-events-none" />

          <CardContent className="p-8 md:p-16 text-center flex flex-col items-center gap-6 relative z-10">
            <div className="w-16 h-16 rounded-md bg-foreground/10 flex items-center justify-center mb-2 rotate-0 transition-transform hover:scale-110">
              <BookOpen className="w-8 h-8 text-foreground" />
            </div>
            
            <div className="space-y-4 max-w-2xl">
              <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold font-default tracking-tighter text-foreground uppercase">
                Ready to define your sound?
              </h2>
              <p className="text-lg md:text-xl text-muted-foreground font-default leading-relaxed">
                Collaborate with Rhythm & Soul Productions. From beat licensing to professional mixing and mastering, let's bring your sonic vision to life with studio precision.
              </p>
            </div>

            <div className="mt-6">
              <Button asChild size="lg" className="rounded-md px-10 h-14 text-lg group bg-primary text-primary-foreground hover:bg-foreground hover:text-background transition-colors animate-pulse">
                <Link to="/ServicesPage">
                  View Service Packages
                  <ArrowRight className="ml-2 w-6 h-6 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}